var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"textField",staticClass:"base-text-field",class:{
    'title-input': _vm.type === 'title',
    'base-text-field--is-dark': _vm.isDark,
  },attrs:{"outlined":"","single-line":"","hide-details":"","disabled":_vm.disabled,"value":_vm.value,"placeholder":_vm.placeholder,"color":"blue"},on:{"input":function($event){return _vm.input($event)},"paste":function($event){return _vm.paste($event)},"blur":_vm.blur}})}
var staticRenderFns = []

export { render, staticRenderFns }